import React from "react";


import restfullySvg from "../../img/restfully-logo.svg";
// import "./index.css";

function Partners() {
  return (
    <div className="App">
      <section style={{ marginTop: '100px' }}>
          <h1 style={{color: "#333",     textAlign: "center",
    marginBottom: "0.5rem"}}>Trusted Resource</h1>
  <p
  style={{
    textAlign: "center",
    fontSize: "1.15rem",
    marginTop: "0.75rem",
    marginBottom: "2.5rem",
    color: "#555",
    maxWidth: "700px",
    marginInline: "auto",
    lineHeight: "1.6"
  }}
>
  An organization we trust and confidently recommend to families.
</p>
        <div 
          className="white-section"
          style={{ 
            display: 'flex',           // make children side by side
            alignItems: 'center',      // vertically center
            gap: '2rem',               // space between logo and text
            flexWrap: 'wrap'           // allow wrapping on small screens
          }}
        >
          {/* Logo Box */}
          <a
  href="https://restfullycare.com"
  target="_blank"
  rel="noopener noreferrer"
  style={{ textDecoration: "none" }}
>
          <div 
            className="phone-image-wrapper"
            style={{
              width: '300px',
              height: '100px',
              backgroundColor: '#637567', 
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '8px',
              overflow: 'hidden'
            }}
          >
            <img 
              src={restfullySvg} 
              alt="Restfully" 
              style={{ width: '80%', height: 'auto' }} 
            />
          </div>
          </a>

          {/* Text Content */}
          {/* <div className="value-prop" style={{ maxWidth: '600px', textAlign: 'center' }}>
            <h2 style={{ fontFamily: "Poppins-Light" }}>
              End-of-Life Planning & Grief Support
            </h2>
            <p style={{ fontSize: "1rem", marginTop: '1rem' }}>
              Tools, guidance, and support to help you plan, honor, and navigate end-of-life and loss with clarity and care.
            </p>
          </div> */}
        </div>
      </section>
    </div>
  );
}

export default Partners;
